// export const url = "https://mirf.academy";
//export const url = "http://localhost:4000";
export const url = "https://login.bnzero.com";